import React from 'react';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import history from './browserHistory'
import routerList from './routerList'


const BasicRoute = () => {
    const currentPath = window.location.pathname;
    const isValidRoute = routerList.some(route => "/" + route.path === currentPath);
    console.log(isValidRoute);
    return (
        <Router history={history} basename='/'>
            {
                routerList.map((routerItem, index) => {
                    console.log('1111111');
                    if ((!routerItem.path && routerItem.path !== "")|| !routerItem.component) {
                        console.error(`Invalid route configuration at index ${index}: path or component is missing.`);
                        return null;
                    }
                    console.log('222222');
                    return <Route exact key={'router' + index} path={"/" + routerItem.path} component={routerItem.component} />;
                })
            }
            {!isValidRoute && <Redirect to="/" />}
        </Router>
    );
};

export default BasicRoute;

